import { Skeleton } from '@/components/ui/skeleton';
import { Anzeige } from '@/domain/controlling/entities/tagebuchAnzeige';

export function ZieleSkeleton({
  tagebuchAnzeige,
}: {
  tagebuchAnzeige: Anzeige;
}) {
  return (
    <>
      {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && (
        <div className="flex flex-col gap-4 grow justify-between">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      )}
      {(tagebuchAnzeige === 'UMSATZ_PRODUKTIVITAET' ||
        tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET') && (
        <div className="flex flex-col gap-4 grow justify-between">
          <Skeleton className="h-20 w-full" />
        </div>
      )}
    </>
  );
}
